import gql from 'graphql-tag'

export const GetTeamStoresQuery = gql`
  query GetTeamStoresList($limit: Int, $offset: Int) {
    teamStoresList(limit: $limit, offset: $offset, withPrivates: true) {
      fullCount
      teamStores {
        id
        shortId: short_id
        name
        banner
        closed
      }
    }
  }
`

export const SearchStoresQuery = gql`
  query SearchTeamStore($searchString: String!, $limit: Int, $offset: Int) {
    searchTeamStores(
      searchParam: $searchString
      limit: $limit
      offset: $offset
    ) {
      fullCount
      teamStores {
        id
        shortId: short_id
        name
        banner
        closed
        private
      }
    }
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/TeamStoreList/data.ts